<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="col-md-12 px-0">
                <router-link class="back-route h3" ref="backBtn" to="" @click="$router.go(-1)">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    Team Name
                </router-link>
            </div>
        </div>

        <div>
            <div class="row tabContent mb-3">
                <div class="tabContent1 col-md-12 mb-5 justify-content-between">
                    <div class="col-md-2 d-flex align-items-center">
                        <h3>{{team.name}}</h3>
                    </div>
                    <div class="cssActionsStyle col-md-2">
<!--                        <font-awesome-icon  :icon="['fas', 'trash']" class="trashDesign" v-if="permissions.includes('delete team')" @click.prevent="DeleteEntity"  size="xl"/>-->
<!--                        &nbsp;&nbsp;&nbsp;&nbsp;-->
<!--                        <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" v-if="permissions.includes('update team')" size="xl" @click.prevent="EditEntity"/>-->
                    </div>
                </div>
            </div>

            <div class="tabcontent" v-if="userTeams.length > 0">
                <div class="table-container">
                    <TableComponent :thead="thead" :tbody="userTeams" :keys="keys" model="usersTeamsScore" name="usersTeamsScore"
                                    updateUrl="/edit-scores" />

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getUserInTeams" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
            </div>
        </div>

<!--        <div v-else class="text-center">No Answer Has Been Submited Yet</div>-->
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";
    import competition from "../../../api-services/competition";
    import repository from "../../../api-services/repository";

    export default {
        name:'pageShowUserInTeams-userscore',
        data(){
            return {
                thead: ['Name' , 'Score' , 'Percentage'],
                keys: ['name' , 'score', 'percentage'],
                permissions: [],
                team:{
                    name:''
                },
                userTeams: [],
                filteredArray: [],
                originalUsertTeams: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false,
                isSearch:false,
                isActive1:false,
                isActive2:false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted(){
            this.getUserInTeams();
            this.permissions = this.$store.state.auth.permissions;
            const entity_id = this.$route.params.id2;
            const responseEntity = await repository.show('entities' , entity_id);
            this.team.name = responseEntity.data.data.name;
        },
        methods:{
            async getUserInTeams(){
                const competition_id = this.$route.params.id1;
                const entity_id = this.$route.params.id2;
                try{
                    const response = await score.getUsersInTeams(competition_id , entity_id);
                    // console.log(response.data.data);
                    this.thead.push(...response.data.data[0].titles);
                    this.keys.push(...response.data.data[0].keysData);
                    this.userTeams = response.data.data;
                    this.laravelData = response.data;
                    this.originalUsertTeams = response.data.data;
                }catch (e) {
                    // console.log(e);
                }
            },
            async DeleteEntity(){
                const entity_id = this.$route.params.id2;
                await repository.delete('models' , entity_id);
                this.$router.push({path: '/results'});
            },
            EditEntity(){
                const entity_id = this.$route.params.id2;
                this.$router.push({path: '/settings/teams/edit/'+entity_id});
            }
        }
    }
</script>

<style scoped>
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .trashDesign {
        color: #FF7171;
        cursor: pointer;
    }
    .cssActionsStyle{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
    .styleDataNotFound{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        height: 80%;
    }
    .tabContent1 {
        display: flex;
        flex-wrap: wrap;
        padding: 30px;
        height: 18vh;
        width: 100%;
        overflow-y: auto;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
        gap: 50px;
    }

    .tabContent {
        display: flex;
        padding: 0;
        margin: 0;
        /*height: 80vh;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 20px;
    }
</style>